<script setup lang="ts">
const { te, t } = useI18n();
const appStateStore = useAppStateStore();

const props = defineProps({
  filter: {
    type: Object as PropType<FiltersOptions>,
    required: true,
  },
  filterKey: {
    type: String,
    required: true,
  },
});

const isFilterOpen = ref(false);
const filterContainer = ref<HTMLElement | null>(null);
const selectedCount = computed(() => {
  return Object.values(props.filter).filter((value) => value).length;
});

const handleFilterKey = (key: string) => {
  if (key === "rarity") return t(`main.toolbar.filter.rarity`);
  if (key.includes(".")) {
    const parts = key.split(".");
    const merchantKey = `${parts[0]}.property.${parts[1]}.title`;
    if (te(merchantKey)) return t(merchantKey);
  }
  if (te(key)) return t(key);
  const fallbackMerchantKey = `${appStateStore.currentMerchant}.property.${key}.title`;
  if (te(fallbackMerchantKey)) return t(fallbackMerchantKey);
  return key;
};

const toggleOpenFilter = () => {
  isFilterOpen.value = !isFilterOpen.value;
};

watch(filterContainer, (newVal) => {
  if (isFilterOpen.value && newVal) {
    newVal.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
});
</script>
<template>
  <div class="flex flex-col items-center justify-between">
    <div
      class="w-full flex items-center justify-between border-b border-secondary-500 px-8 py-4 cursor-pointer text-neutral-200"
      @click="toggleOpenFilter">
      <div class="flex items-baseline gap-2">
        <p class="text-lg">
          {{ handleFilterKey(props.filterKey) }}
        </p>
        <p class="text-sm">
          {{ selectedCount ? `(${selectedCount})` : "" }}
        </p>
      </div>
      <NuxtIcon
        name="mdi:keyboard-arrow-down"
        class="w-7 h-7 transition-all duration-300 shrink-0"
        :class="{ 'transform rotate-180': isFilterOpen }" />
    </div>
    <transition
      enter-active-class="transition ease duration-100"
      enter-from-class="transform opacity-0 -translate-y-5"
      enter-to-class="transform opacity-100 translate-y-0"
      leave-active-class="transition ease duration-100"
      leave-from-class="transform opacity-100 translate-y-0"
      leave-to-class="transform opacity-0 -translate-y-5">
      <div
        v-if="isFilterOpen"
        ref="filterContainer"
        class="w-full flex flex-col justify-center gap-4 border-b border-secondary-500 px-8 py-4 transition-all duration-300 bg-neutral-500">
        <template v-for="(_value, key) in filter" :key="key">
          <ToolbarFiltersOptionsChoice
            v-model="filter[key]"
            :filter-value="(key as string)"
            :property-value="filterKey" />
        </template>
      </div>
    </transition>
  </div>
</template>
